import {F_PREFFERENCE} from '../constants';

const secondStepData = window?.drupalSettings?.booking?.secondStep;
export const pageTitle = secondStepData?.pageTitle;
export const freeCancelationText = secondStepData?.freeCancelationText;
export const loginBlock = secondStepData?.loginBlock;
export const yourDataBlock = window?.drupalSettings?.booking?.secondStep?.yourDataBlock;
export const blockFormFields = window?.drupalSettings?.booking?.secondStep?.yourDataBlock?.blockForm?.fields;
export const preferenceData = yourDataBlock?.blockForm?.fields?.[F_PREFFERENCE] || null
export const detailInfoBlock = secondStepData?.detailInfoBlock;
export const dataLayerPayment = window.drupalSettings?.dataLayer?.payment;
export const bookingAttemptOut = window.drupalSettings?.bookingAttemptOut;
export const secondStepMeta = secondStepData?.meta;
export const secondStepApiUrls = secondStepData?.api;
export const confirmReservationBlock = secondStepData?.confirmReservationBlock;
export const paymentDetailsBlock = secondStepData?.paymentDetailsBlock
export const formValidators = window?.drupalSettings?.formControls?.validators;

export default window?.drupalSettings;
